import { API } from 'utils';
import { OnboardingList } from 'components/tour/tour.types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';
import { TourRegistryKey } from 'components/tour/tour.registry';

const { C300 } = GW_SERVICES_PREFIXES;

/* Получение информации об онбоардинге */
export const GetOnboardingInfo = (): Promise<OnboardingList> =>
  API.get(`/${C300}/models/worker_onboarding/`);

/* Обновление статуса онбоардинга сотрудником */
export const PatchOnboardingInfo = (data: {
  block: TourRegistryKey;
  viewed: boolean;
  version: number;
}): Promise<OnboardingList> =>
  API.gatewayPatch(`/${C300}/models/worker_onboarding/`, undefined, data);
